var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowMinDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ic / Arrow min down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.7108 8.70986C18.6178 8.61613 18.5072 8.54174 18.3854 8.49097C18.2635 8.4402 18.1328 8.41406 18.0008 8.41406C17.8688 8.41406 17.7381 8.4402 17.6162 8.49097C17.4944 8.54174 17.3838 8.61613 17.2908 8.70986L12.7108 13.2899C12.6178 13.3836 12.5072 13.458 12.3854 13.5087C12.2635 13.5595 12.1328 13.5856 12.0008 13.5856C11.8688 13.5856 11.7381 13.5595 11.6162 13.5087C11.4944 13.458 11.3838 13.3836 11.2908 13.2899L6.71079 8.70986C6.61783 8.61613 6.50723 8.54174 6.38537 8.49097C6.26351 8.4402 6.1328 8.41406 6.00079 8.41406C5.86878 8.41406 5.73808 8.4402 5.61622 8.49097C5.49436 8.54174 5.38376 8.61613 5.29079 8.70986C5.10454 8.89722 5 9.15067 5 9.41486C5 9.67904 5.10454 9.9325 5.29079 10.1199L9.88079 14.7098C10.4433 15.2716 11.2058 15.5872 12.0008 15.5872C12.7958 15.5872 13.5583 15.2716 14.1208 14.7098L18.7108 10.1199C18.897 9.9325 19.0016 9.67904 19.0016 9.41486C19.0016 9.15067 18.897 8.89722 18.7108 8.70986Z",
    fill: "#3A41BA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowMinDown);
export default __webpack_public_path__ + "static/media/Arrow-min-down.0f976738944bca087a7a549af18c3923.svg";
export { ForwardRef as ReactComponent };